import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';

/**
 * Supplies the height of wrapped component's children as
 *   a property called _height_.
 * Preference should be to NOT use this, but to rely on the correct use
 *   of styles to size a component.
 * @param {React.Component} Component The component in which to wrap.
 */
function enhanceWithChildrenHeight(Component) {
  class EnhancedComponent extends React.Component {
    state = { height: undefined };

    componentDidMount() {
      window.addEventListener('resize', this.setHeight);
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.setHeight);
    }

    setHeight = () => {
      const wrapper = ReactDOM.findDOMNode(this.wrapper); // eslint-disable-line react/no-find-dom-node
      if (wrapper) {
        this.setState({
          height: wrapper.scrollHeight,
        });
      }
    };

    setWrapper = (element) => {
      this.wrapper = element;
      this.setHeight();
    };

    render() {
      const { children, ...props } = this.props;

      return (
        <Component height={this.state.height} {...props}>
          <div ref={this.setWrapper}>
            { children }
          </div>
        </Component>
      );
    }
  }

  EnhancedComponent.propTypes = {
    /* The wrapped component's children */
    children: PropTypes.node,
  };

  return EnhancedComponent;
}

export default enhanceWithChildrenHeight;
